import Panel from './Panel';
import PanelBody from './PanelBody';
import PanelHeader from './PanelHeader';

// export types
export type { PanelProps } from './Panel';
export type { PanelBodyProps } from './PanelBody';
export type { PanelHeaderProps } from './PanelHeader';

// export components
export { Panel, PanelBody, PanelHeader };
export default Panel;
